export default __webpack_public_path__ + "static/media/cliente5.3a30b22e.jpg";